module.exports = __webpack_public_path__ + "img/honoral1.783b1d3a.jpg";